
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quote/list/[id]/quote-page",
      function () {
        return require("private-next-pages/quote/list/[id]/quote-page/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quote/list/[id]/quote-page"])
      });
    }
  